import DefinitionTypes from "../definition-types";

export const isCustomChallenge = ({ discoveryChallenge }) => {
  return discoveryChallenge?.definition?.status === DefinitionTypes.NEW;
};

export const isTypicalChallenge = (discoveryChallenge) => {
  return discoveryChallenge?.selectedByDefault;
};
